// Quem e o cliente do pedido, derivado do usuario logado. Fica aqui, e nao dentro do
// `confirma()`, para a tela de confirmacao mostrar exatamente o que vai ser gravado -
// antes ela lia de `sacola.cliente`, que nunca era preenchido.
export type ClientePedido = {
  identificador: string;
  nome: string;
  // Ausente no login por telefone: `pedidoCliente.email` recusa string vazia (minimo 8).
  email?: string;
  imagem: string;
  telefone?: string;
};

// De onde veio o login. Sem `origem`, e Google: e como entrava quem logou antes do telefone.
export type ClienteOrigem = 'google' | 'telefone';

export const CLIENTE_IMAGEM_PADRAO = 'avatar-s-11.jpg';

// Prefixo do login Google no identificador do cliente. O `agente/cliente` indexa por
// `G{sub}` (GET e POST), entao pedido e cliente TEM de usar a mesma chave, senao o pedido
// nao casa com o cliente cadastrado. Fica aqui, num lugar so, para os dois lerem daqui.
export const CLIENTE_PREFIXO_GOOGLE = 'G';

// Login por telefone (CON-3683): `T{DDD+numero}`, so digitos, no mesmo desenho do `G`.
export const CLIENTE_PREFIXO_TELEFONE = 'T';

// O backend exige identificador com 10+ caracteres e SEM espacos. O `sub` do Google ja
// atende; o prefixo `G` amarra o pedido ao cliente do `agente/cliente`. Sem `sub`, cai no
// email (que nao leva prefixo - nao e id do Google).
function identificadorDe(id: string, email: string): string {
  const limpo = (id || '').replace(/\s/g, '');
  return limpo.length >= 10 ? CLIENTE_PREFIXO_GOOGLE + limpo : email || limpo;
}

// O Google devolve nomes como "Bruno - Clinica"; o backend so quer a primeira parte.
//
// O corte NUNCA pode zerar o nome. Conta cujo nome comeca com hifen - acontece em conta
// Workspace, onde o `family_name` vem "- Empresa" e o `given_name` vem vazio - caia em
// string vazia, e o `pedido/grava` recusa com "cliente should not be empty": mensagem que
// parece falar do cliente inteiro, mas fala so do nome.
function nomeDe(primeiro: string, ultimo: string, email: string): string {
  const nome = `${primeiro || ''} ${ultimo || ''}`.trim();
  const cortado = nome.includes('-') ? nome.split('-')[0].trim() : nome;
  return cortado || nome || email || 'Cliente';
}

export function clientePedidoMonta(usuario: {
  id?: any;
  firstName?: string;
  lastName?: string;
  email?: string;
  avatar?: string;
  origem?: ClienteOrigem;
  telefone?: string;
}): ClientePedido | null {
  if (!usuario) {
    return null;
  }
  if (usuario.origem === 'telefone') {
    return {
      identificador: CLIENTE_PREFIXO_TELEFONE + (usuario.telefone || ''),
      nome: (usuario.firstName || '').trim() || 'Cliente',
      imagem: usuario.avatar || CLIENTE_IMAGEM_PADRAO,
      telefone: usuario.telefone,
    };
  }
  const email = usuario.email || '';
  return {
    identificador: identificadorDe(usuario.id?.toString() || '', email),
    nome: nomeDe(usuario.firstName, usuario.lastName, email),
    email,
    imagem: usuario.avatar || CLIENTE_IMAGEM_PADRAO,
  };
}
